<template>
	<v-container grid-list-xl privContainer>
		<v-layout row wrap>					
			<v-flex lg12>
				<!--<p>Choose the privileges assigned to the role.</p>-->
              <v-flex xs3 style="padding-left: 0px !important;">
                <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field>
              </v-flex>
				<v-data-table :headers="headers" :pagination.sync="pagination" :search="search" :items="objRolePrivs" class="elevation-1 linkTableMediumSmall" hide-actions :rows-per-page-items="[1000]" style="font-size: 10px;">
					<template slot="items" slot-scope="props">						
						<td width="10%" ><v-switch label="" v-model="props.item.privActive" @click="fncSetPrivStatus( props.item.id, props.item.privActive )"></v-switch></td>      											
						<td width="45%" >{{ props.item.priv_key }}</td>
						<td width="45%" >{{ props.item.description }}</td>					
					</template>
				</v-data-table>
			</v-flex>			
			<div class="pl-4 pr-3 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="cancelButton" @click.stop="fncHideModal">Close</v-btn>
				</div>
			</div>
			<v-flex lg12 class="requiredMessage">
				&nbsp;
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
				search: '',	
				roleActive: false,
				roleName: '',
				roleDescription: '',
				roleLevel: '',
                roleUserType: '',
                pagination: {
                  sortBy: 'priv_key'
                },
				headers: [         
					{ text: '', value: 'active', width: '10%' },
                    { text: 'PRIV KEY', value: 'priv_key', width: '45%' },
                    { text: 'DESCRIPTION', value: 'description', width: '45%' }					
				]	
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');				
			},
			fncSetPrivStatus(privId, privStatus) {
				if(privStatus == true) {
					privStatus = false;
				} else {
					privStatus = true;
				}
				this.$store.commit({
					type: 'setPrivStatus',
					privStatus: privStatus,
					privId: privId
				})
				if(privStatus == true) {
					this.$store.dispatch({
						type: 'fncLinkRolePriv',
						roleId: this.globalModalParams,
						privId: privId
					})
				} else {
					this.$store.dispatch({
						type: 'fncUninkRolePriv',
						roleId: this.globalModalParams,
						privId: privId
					})
				}
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd',
				'objRoleEdit',				
				'objRolePrivs',
				'globalModalParams'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>